export default __webpack_public_path__ + "static/media/dva-ult.cfce27a6.mp3";